import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "./user.service";
import { setReferralCookies } from "@modules/social-trading/helpers/cookies";
import { take } from "rxjs/operators";
import { TradableListService } from "./currency/tradable_list.service";
import { PathResolverService } from "@main-services/path-resolver.service";

@Injectable({
	providedIn: "root"
})
export class SharePriceGuard {
	constructor(
		private readonly router: Router,
		private readonly userService: UserService,
		private readonly tradableListService: TradableListService,
		private readonly pathResolverService: PathResolverService
	) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const { refId, assetId } = route.params;
		setReferralCookies(refId);
		this.userService
			.getSession()
			.pipe(take(1))
			.subscribe((isSessionValid: boolean) => {
				if (isSessionValid) {
					this.redirectToAssetDetails(assetId);
				} else {
					this.redirectToLogin(state.url);
				}
			});
		return false;
	}

	private redirectToAssetDetails(assetId: string): void {
		const tradable = this.tradableListService.getItemById(assetId);
		if (!tradable) {
			this.router.navigateByUrl("home");
		} else {
			this.router.navigateByUrl(this.pathResolverService.assetDetails(tradable));
		}
	}

	private redirectToLogin(inviteURL: string): void {
		this.userService.redirect = inviteURL;
		this.router.navigateByUrl("/user/login");
	}
}
